import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

let cart = window.localStorage.getItem("cart");

export default new Vuex.Store({
  state: {
    session: {
      uid: null,
      isAuth: false,
      isReg: false,
      err: null
    },
    user: null,
    userOrders: {
      sell: [],
      buy: []
    },
    cart: cart ? JSON.parse(cart) : [],
    cartCount: cart ? cartCount(JSON.parse(cart)) : 0,
    fullAmount: cart ? fullAmount(JSON.parse(cart)) : 0.0,
    GlobalData: {
      products: null,
      categories: null,
      sizes: null,
      brands: null,
      collections: null,
      orders: null,
      partners: null,
      cities: null,
      currentCity: null,
      news: null,
      ads: null
    }
  },
  mutations: {
    addToCart(state, item) {
      //let found = false;
      /*for (let i = 0; i < state.cart.length; i++) {
        if (state.cart[i].id === item.id) {
          found = true;
        }
      }*/
      /*if (found) {
        item.quantity++;
        item.totalPrice = (item.quantity * item.price).toFixed(2);
      } else {
        
      }*/
      let obj = {};
      for (let k in item) {
        obj[k] = item[k];
      }
      state.cart.push(obj);
      Vue.set(item, "totalPrice", item.price * item.quantity);
      state.fullAmount = fullAmount(state.cart);
      state.cartCount = cartCount(state.cart);
      this.commit("saveCart");
    },
    removeFromCart(state, item) {
      let index = state.cart.indexOf(item);
      if (index > -1) {
        let product = state.cart[index];
        state.cartCount -= product.quantity;
        state.cart.splice(index, 1);
      }
      this.commit("saveCart");
      state.fullAmount = fullAmount(state.cart);
    },
    saveCart(state) {
      window.localStorage.setItem("cart", JSON.stringify(state.cart));
      window.localStorage.setItem("cartCount", state.cartCount);
    },
    changeSession(state, val) {
      state.session = val;
    },
    changeUser(state, val) {
      state.user = val;
    },
    userOrders(state, val) {
      state.userOrders = val;
    },
    changeGlobalData(state, val) {
      state.GlobalData = val;
    }
  },
  actions: {
    startSession({ dispatch, commit }, session) {
      commit("changeSession", session);
      if (!session.isReg) {
        dispatch("loadUser");
      }
    },
    loadUser({ commit }) {
      axios
        .post("/.netlify/functions/user-get", this.state.session)
        .then(function(res) {
          res.data.data.id = res.data.ref["@ref"].id;
          res.data.data.phone_formatted = res.data.data.phone_formatted.replace(
            "+38",
            ""
          );
          if (res.data.data.logo) {
            let obj = {
              source: res.data.data.logo
                .split("/")
                .splice(5, 4)
                .join("/")
                .toString(),
              options: { type: "local" }
            };
            res.data.data.kostil = [obj];
          }

          axios
            .post("/.netlify/functions/orders-get-user", {
              userId: res.data.data.id
            })
            .then(orders => {
              let buy = [];
              let sales = [];
              let ordersData = orders.data.myOrders;
              for (let i = 0; i < ordersData.length; i++) {
                ordersData[i].data.id = ordersData[i].ref["@ref"].id;
                ordersData[i].data.date = timeConverter(ordersData[i].ts);
                buy.push(ordersData[i].data);
              }

              let salesData = orders.data.mySales;
              for (let s = 0; s < salesData.length; s++) {
                salesData[s].data.id = salesData[s].ref["@ref"].id;
                salesData[s].data.date = timeConverter(salesData[s].ts);
                sales.push(salesData[s].data);
              }

              commit("userOrders", { buy: buy, sell: sales });
            });

          commit("changeUser", res.data.data);
        });
    },
    async loadAllData({ commit }) {
      if (
        !this.state.GlobalData.categories &&
        !this.state.GlobalData.products &&
        !this.state.GlobalData.sizes &&
        !this.state.GlobalData.brands
      ) {
        let data = {
          categories: [],
          products: [],
          sizes: [],
          type_shoes: [],
          colors: [],
          collections: [],
          orders: [],
          partners: [],
          cities: [],
          currentCity: {},
          users: [],
          adults: [],
          news: [],
          ads: []
        };
        // let publicData = await axios.get("/.netlify/functions/public-data");
        let publicData = await axios.get("/publicData.json");
        console.log(JSON.stringify(publicData.data));
        if (publicData.data.categories) {
          for (let i = 0; i < publicData.data.categories.length; i++) {
            publicData.data.categories[i].data.index = i + 1;
            publicData.data.categories[i].data.id =
              publicData.data.categories[i].ref["@ref"].id;
            publicData.data.categories[i].data.ready = false;
            publicData.data.categories[i].data.toggleShow = false;
            if (!publicData.data.categories[i].data.description) {
              publicData.data.categories[i].data.description = {
                ru: "",
                uk: ""
              };
            }
            if (!publicData.data.categories[i].data.typePage) {
              publicData.data.categories[i].data.typePage = 0;
            }
            if (!publicData.data.categories[i].data.adults) {
              publicData.data.categories[i].data.adults = [];
            }
            data.categories.push(publicData.data.categories[i].data);
          }
          data.categories.sort((a, b) => {
            if (a.position < b.position) return -1;
            else if (a.position > b.position) return 1;
          });
        }
        if (publicData.data.products) {
          for (let p = 0; p < publicData.data.products.length; p++) {
            publicData.data.products[p].data.id =
              publicData.data.products[p].ref["@ref"].id;
            publicData.data.products[p].data.price =
              publicData.data.products[p].data.price / 100;
            if (publicData.data.products[p].data.images.length > 0) {
              publicData.data.products[p].data.kostil = [];
              for (
                let i = 0;
                i < publicData.data.products[p].data.images.length;
                i++
              ) {
                let obj = {
                  source: publicData.data.products[p].data.images[i]
                    .split("/")
                    .splice(5, 4)
                    .join("/")
                    .toString(),
                  options: { type: "local" }
                };
                publicData.data.products[p].data.kostil.push(obj);
              }
            }
            publicData.data.products[p].data.err = false;
            publicData.data.products[p].data.ready = false;
            publicData.data.products[p].data.selectAll = false;
            if (!publicData.data.products[p].data.sizes) {
              publicData.data.products[p].data.sizes = [];
            }
            data.products.push(publicData.data.products[p].data);
          }
        }
        if (publicData.data.sizes) {
          for (let s = 0; s < publicData.data.sizes.length; s++) {
            publicData.data.sizes[s].data.id =
              publicData.data.sizes[s].ref["@ref"].id;
            publicData.data.sizes[s].data.ready = false;
            data.sizes.push(publicData.data.sizes[s].data);
          }
        }
        if (publicData.data.type_shoes) {
          for (let s = 0; s < publicData.data.type_shoes.length; s++) {
            publicData.data.type_shoes[s].data.id =
              publicData.data.type_shoes[s].ref["@ref"].id;
            publicData.data.type_shoes[s].data.ready = false;
            data.type_shoes.push(publicData.data.type_shoes[s].data);
          }
        }
        if (publicData.data.colors) {
          for (let s = 0; s < publicData.data.colors.length; s++) {
            publicData.data.colors[s].data.id =
              publicData.data.colors[s].ref["@ref"].id;
            publicData.data.colors[s].data.ready = false;
            data.colors.push(publicData.data.colors[s].data);
          }
        }
        if (publicData.data.partners) {
          for (let i = 0; i < publicData.data.partners.length; i++) {
            publicData.data.partners[i].data.id =
              publicData.data.partners[i].ref["@ref"].id;
            if (publicData.data.partners[i].data.logo) {
              publicData.data.partners[i].data.kostil = [
                {
                  source: publicData.data.partners[i].data.logo
                    .split("/")
                    .splice(5, 4)
                    .join("/")
                    .toString(),
                  options: { type: "local" }
                }
              ];
            }
            data.partners.push(publicData.data.partners[i].data);
          }
          data.partners.sort((a, b) => {
            if (a.position < b.position) return -1;
            else if (a.position > b.position) return 1;
          });
        }
        if (publicData.data.cities) {
          let domain =
            window.location.hostname === "localhost"
              ? "obuv.dp.ua"
              : window.location.hostname;
          for (let i = 0; i < publicData.data.cities.length; i++) {
            publicData.data.cities[i].data.id =
              publicData.data.cities[i].ref["@ref"].id;
            data.cities.push(publicData.data.cities[i].data);
            for (
              let c = 0;
              c < publicData.data.cities[i].data.domains.length;
              c++
            ) {
              if (domain === publicData.data.cities[i].data.domains[c]) {
                data.currentCity = publicData.data.cities[i].data;
              }
            }
          }
        }

        if (publicData.data.users) {
          data.users = publicData.data.users;
        }

        if (publicData.data.adults) {
          for (let s = 0; s < publicData.data.adults.length; s++) {
            publicData.data.adults[s].data.id =
              publicData.data.adults[s].ref["@ref"].id;
            publicData.data.adults[s].data.ready = false;
            data.adults.push(publicData.data.adults[s].data);
          }
        }

        if (publicData.data.news) {
          for (let s = 0; s < publicData.data.news.length; s++) {
            publicData.data.news[s].data.id =
              publicData.data.news[s].ref["@ref"].id;
            publicData.data.news[s].data.ready = false;
            publicData.data.news[s].data.index = s + 1;
            publicData.data.news[s].data.date = timeConverter(
              publicData.data.news[s].ts
            );
            if (publicData.data.news[s].data.image) {
              publicData.data.news[s].data.kostil = [
                {
                  source: publicData.data.news[s].data.image
                    .split("/")
                    .splice(5, 4)
                    .join("/")
                    .toString(),
                  options: { type: "local" }
                }
              ];
            }
            data.news.push(publicData.data.news[s].data);
          }
        }

        if (publicData.data.ads) {
          for (let s = 0; s < publicData.data.ads.length; s++) {
            publicData.data.ads[s].data.id =
              publicData.data.ads[s].ref["@ref"].id;
            publicData.data.ads[s].data.ready = false;
            publicData.data.ads[s].data.index = s + 1;
            publicData.data.ads[s].data.date = timeConverter(
              publicData.data.ads[s].ts
            );
            if (publicData.data.ads[s].data.image) {
              publicData.data.ads[s].data.kostil = [
                {
                  source: publicData.data.ads[s].data.image
                    .split("/")
                    .splice(5, 4)
                    .join("/")
                    .toString(),
                  options: { type: "local" }
                }
              ];
            }
            data.ads.push(publicData.data.ads[s].data);
          }
        }
        commit("changeGlobalData", data);
      } else {
        console.log("Get data in store");
        commit("changeGlobalData", this.state.GlobalData);
      }
    }
  }
});

function fullAmount(items) {
  let amount = 0;
  if (items.length > 0) {
    for (let i = 0; i < items.length; i++) {
      amount += parseInt(items[i].price) * 100 * parseInt(items[i].quantity);
    }
  }
  return parseFloat(amount / 100).toFixed(2);
}

function cartCount(items) {
  let count = 0;
  if (items.length > 0) {
    for (let i = 0; i < items.length; i++) {
      count += parseInt(items[i].quantity);
    }
  }
  return count;
}

function timeConverter(UNIX_timestamp) {
  let a = new Date(UNIX_timestamp / 1000);
  let months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
  ];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate();
  // let hour = a.getHours();
  // let min = a.getMinutes();
  // let sec = a.getSeconds();
  let time =
    date +
    " " +
    month +
    " " +
    year; /*+
    " " +
    (hour.toString().length !== 1 ? hour : "0" + hour) +
    ":" +
    (min.toString().length !== 1 ? min : "0" + min) +
    ":" +
    sec*/
  return time;
}
